import * as z from "zod/v4";

export const endAbTest = {
  name: "endAbTest" as const,
  input: z.object({ testId: z.string() }),
  output: z.object({
    id: z.string(),
    type: z.enum(["imessage_channel"]),
    status: z.enum(["active", "ended"]),
    name: z.string(),
    startedAt: z.date(),
    endedAt: z.date().nullable(),
  }),
};
